module.exports = __webpack_public_path__ + "static/bgImage-c110623ece7648af51adef3e334d3847.jpg";